import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import "./DocumentViewer.css";

const DocumentViewer = ({ htmlContent }) => {
  // Function to extract content between <Document> tags
  const extractDocumentContent = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const documentTag = doc.querySelector("Document");

    if (!documentTag) {
      console.error("<Document> tags not found in the provided HTML.");
      return [];
    }

    const pages = [];
    const pageTags = documentTag.querySelectorAll("Page");

    if (pageTags.length === 0) {
      // If no <Page> tags, treat the entire content as a single page
      pages.push(documentTag.innerHTML);
    } else {
      pageTags.forEach((page) => {
        pages.push(page.innerHTML);
      });
    }

    return pages;
  };

  const pages = extractDocumentContent(htmlContent);

  return (
    <div className="document-viewer">
      {pages.map((pageContent, index) => (
        <div className="a4-page" key={index}>
          <div className="page-content">{parse(pageContent)}</div>
        </div>
      ))}
    </div>
  );
};

DocumentViewer.propTypes = {
  htmlContent: PropTypes.string.isRequired,
};

export default DocumentViewer;